import { Callback, ExtraAction, apiCall, createApiRequestPayload } from '..';
import { Article } from '../../../../model/Article';

const BASE_PATH = `/api/crm/articles`;

export const findArticlesByQuery = (
  apiQuery: Map<string, string>,
  successActionName: string,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
  callbacks?: Array<Callback> | null,
) => {
  const urlPathParameters = Array.from(apiQuery.entries())
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  const apiPath = `${BASE_PATH}?${urlPathParameters}`;
  console.log(`apiPath`, apiPath);
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'GET',
    undefined,
    customErrorsMap,
    extraActions,
    callbacks,
  );
  return apiCall(requestPayload);
};

export const findArticleByCategory = (
  category: string,
  successActionName: string,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
  callbacks?: Array<Callback> | null,
) => {
  const apiPath = `/api/public/articles/detail/${category}`;
  console.log(`apiPath`, apiPath);
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'GET',
    undefined,
    customErrorsMap,
    extraActions,
    callbacks,
  );
  return apiCall(requestPayload);
}; // Find article template by category
export const findArticlesTemplateByCategory = (
  category: string,
  successActionName: string,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
) => {
  const apiPath = `${BASE_PATH}/${category}/template`;
  console.log(`apiPath`, apiPath);
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'GET',
    undefined,
    customErrorsMap,
    extraActions,
  );
  return apiCall(requestPayload);
};

export const updateArticle = (
  article: Article,
  successActionName: string,
  callbacks?: Array<Callback>,
  extraActions?: Array<ExtraAction>,
) => {
  const apiPath = `${BASE_PATH}/${article.id}`;
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'PUT',
    article,
    undefined,
    extraActions,
    callbacks,
  );
  return apiCall(requestPayload);
}; // Delete article
export const deleteArticle = (
  articleId: number,
  successActionName: string,
  callbacks?: Array<Callback>,
  extraActions?: Array<ExtraAction>,
) => {
  const apiPath = `${BASE_PATH}/${articleId}`;
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'DELETE',
    undefined,
    undefined,
    extraActions,
    callbacks,
  );
  return apiCall(requestPayload);
};

export const createArticle = (
  article: Article,
  successActionName: string,
  callbacks?: Array<Callback>,
  extraActions?: Array<ExtraAction>,
) => {
  const requestPayload = createApiRequestPayload(
    BASE_PATH,
    successActionName,
    'POST',
    article,
    undefined,
    extraActions,
    callbacks,
  );
  return apiCall(requestPayload);
};
